export const baseImageUrl = `https://jphbwllfvhpwixzpjxnd.supabase.co/storage/v1/object/public/upload`;

export const basePresImageUrl =`https://jphbwllfvhpwixzpjxnd.supabase.co/storage/v1/object/public/prescription.upload`;

// Classic POS single-entry + order list for wholesale.
// Keep false in production; set true only in control/staging to enable new UX.
export const ENABLE_WHOLESALE_QUICK_ENTRY = true;

export const glassItemType = [
  { label: "CR 70", value: "CR 70" },
  { label: "HC", value: "HC" },
  { label: "HC 55", value: "HC 55" },
  { label: "MC", value: "MC" },
  { label: "MC 55", value: "MC 55" },
  { label: "MC PG", value: "MC PG" },
  { label: "MC PB", value: "MC PB" },
  { label: "MC PC", value: "MC PC" },
  { label: "MC PG PC", value: "MC PG PC" },
  { label: "MC 1.67", value: "MC 1.67" },
  { label: "BC", value: "BC" },
  { label: "BC ET", value: "BC ET" },
  { label: "BC 55", value: "BC 55" },
  { label: "BC 1.67", value: "BC 1.67" },
  { label: "BC PC", value: "BC PC" },
  { label: "BC PG-B", value: "BC PG-B" },
  { label: "BC PG-G", value: "BC PG-G" },
  { label: "WT", value: "WT" },
  { label: "WT MC", value: "WT MC" },
  { label: "WT MC PG", value: "WT MC PG" },
  { label: "PG Glass", value: "PG Glass" },
  { label: "PB Glass", value: "PB Glass" },
  { label: "WT KT", value: "WT KT" },
  { label: "PG KT", value: "PG KT" },
  { label: "PB KT", value: "PB KT" },
  { label: "HC KT", value: "HC KT" },
  { label: "MC KT", value: "MC KT" },
  { label: "MC PG KT", value: "MC PG KT" },
  { label: "BC KT", value: "BC KT" },
  { label: "BC PG KT Green", value: "BC PG KT Green" },
  { label: "BC PG KT Blue", value: "BC PG KT Blue" },
  { label: "HC D", value: "HC D" },
  { label: "MC D", value: "MC D" },
  { label: "MC PG D", value: "MC PG D" },
  { label: "BC PG D Green", value: "BC PG D Green" },
  { label: "BC PG D Blue", value: "BC PG D Blue" },
  { label: "HC Prog.", value: "HC Prog." },
  { label: "MC Prog.", value: "MC Prog." },
  { label: "MC PG Prog.", value: "MC PG Prog." },
  { label: "BC Prog.", value: "BC Prog." },
  { label: "BC PG Prog.", value: "BC PG Prog." },

  // Karkhana KT
  { label: "K. WT KT", value: "K. WT KT" },
  { label: "K. WT KT Ger.", value: "K. WT KT Ger." },
  { label: "K. PG KT", value: "K. PG KT" },
  { label: "K. PG KT KT Ger.", value: "K. PG KT KT Ger." },
  { label: "K. PB KT", value: "K. PB KT" },
  { label: "K. PB KT KT Ger.", value: "K. PB KT KT Ger." },

  // Karkhana D
  { label: "K. WT D", value: "K. WT D" },
  { label: "K. WT D Ger.", value: "K. WT D Ger." },
  { label: "K. PG D", value: "K. PG D" },
  { label: "K. PG D Ger.", value: "K. PG D Ger." },
  { label: "K. PB D", value: "K. PB D" },
  { label: "K. PB D Ger.", value: "K. PB D Ger." },

  //  Lab KT
  { label: "Lab CR KT", value: "Lab CR KT" },
  { label: "Lab HC KT", value: "Lab HC KT" },
  { label: "Lab BC KT", value: "Lab BC KT" },
  { label: "Lab FMC KT", value: "Lab FMC KT" },
  { label: "Lab FMC PG KT", value: "Lab FMC PG KT" },
  { label: "Lab FMC PB KT", value: "Lab FMC PB KT" },
  { label: "Lab DMC KT", value: "Lab DMC KT" },
  { label: "Lab DMC PG KT", value: "Lab DMC PG KT" },
  { label: "Lab DMC PB KT", value: "Lab DMC PB KT" },

  //  Lab D
  { label: "Lab CR D", value: "Lab CR D" },
  { label: "Lab HC D", value: "Lab HC D" },
  { label: "Lab BC D", value: "Lab BC D" },
  { label: "Lab FMC D", value: "Lab FMC D" },
  { label: "Lab FMC PG D", value: "Lab FMC PG D" },
  { label: "Lab FMC PB D", value: "Lab FMC PB D" },
  { label: "Lab DMC D", value: "Lab DMC D" },
  { label: "Lab DMC PG D", value: "Lab DMC PG D" },
  { label: "Lab DMC PB D", value: "Lab DMC PB D" },

  //  Lab progressives
  { label: "Lab CR Prog.", value: "Lab CR Prog." },
  { label: "Lab HC Prog.", value: "Lab HC Prog." },
  { label: "Lab BC Prog.", value: "Lab BC Prog." },
  { label: "Lab FMC Prog.", value: "Lab FMC Prog." },
  { label: "Lab FMC PG Prog.", value: "Lab FMC PG Prog." },
  { label: "Lab FMC PB Prog.", value: "Lab FMC PB Prog." },
  { label: "Lab DMC Prog.", value: "Lab DMC Prog." },
  { label: "Lab DMC PG Prog.", value: "Lab DMC PG Prog." },
  { label: "Lab DMC PB Prog.", value: "Lab DMC PB Prog." },
  { label: "Lab FMC BC PG Prog.", value: "Lab FMC BC PG Prog." },
  { label: "Lab DMC BC Prog.", value: "Lab DMC BC Prog." },
  { label: "Misc.", value: "Misc." },
];

export const GenericGlassTypes = [
  { label: "Misc.", value: "Misc." },
  { label: "CR 70", value: "CR 70" },
  { label: "HC", value: "HC" },
  { label: "HC 55", value: "HC 55" },
  { label: "MC", value: "MC" },
  { label: "MC 55", value: "MC 55" },
  { label: "MC 1.67", value: "MC 1.67" },
  { label: "MC PG", value: "MC PG" },
  { label: "MC PB", value: "MC PB" },
  { label: "MC PC", value: "MC PC" },
  { label: "BC", value: "BC" },
  { label: "BC ET", value: "BC ET" },
  { label: "BC 55", value: "BC 55" },
  { label: "BC 1.67", value: "BC 1.67" },
  { label: "BC PC", value: "BC PC" },
  { label: "BC PG-B", value: "BC PG-B" },
  { label: "BC PG-G", value: "BC PG-G" },
  { label: "WT", value: "WT" },
  { label: "WT MC", value: "WT MC" },
  { label: "WT MC PG", value: "WT MC PG" },
  { label: "PG Glass", value: "PG Glass" },
  { label: "PB Glass", value: "PB Glass" },
  { label: "WT KT", value: "WT KT" },
  { label: "PG KT", value: "PG KT" },
  { label: "PB KT", value: "PB KT" },
  { label: "HC KT", value: "HC KT" },
  { label: "MC KT", value: "MC KT" },
  { label: "MC PG KT", value: "MC PG KT" },
  { label: "BC KT", value: "BC KT" },
  { label: "BC PG KT Green", value: "BC PG KT Green" },
  { label: "BC PG KT Blue", value: "BC PG KT Blue" },
  { label: "HC D", value: "HC D" },
  { label: "MC D", value: "MC D" },
  { label: "MC PG D", value: "MC PG D" },
  { label: "BC PG D Green", value: "BC PG D Green" },
  { label: "BC PG D Blue", value: "BC PG D Blue" },
  { label: "HC Prog.", value: "HC Prog." },
  { label: "MC Prog.", value: "MC Prog." },
  { label: "MC PG Prog.", value: "MC PG Prog." },
  { label: "BC Prog.", value: "BC Prog." },
  { label: "BC PG Prog.", value: "BC PG Prog." },
];
export const glassRanges = [
  
  //Bifocal -
  { label: "Plain to -3.00 Add +3.00", value: "Plain to -3.00 Add +3.00" },
  { label: "Plain to -3.00 Add +2.75", value: "Plain to -3.00 Add +2.75" },
  { label: "Plain to -3.00 Add +2.50", value: "Plain to -3.00 Add +2.50" },
  { label: "Plain to -3.00 Add +2.25", value: "Plain to -3.00 Add +2.25" },
  { label: "Plain to -3.00 Add +2.00", value: "Plain to -3.00 Add +2.00" },
  { label: "Plain to -3.00 Add +1.75", value: "Plain to -3.00 Add +1.75" },
  { label: "Plain to -3.00 Add +1.50", value: "Plain to -3.00 Add +1.50" },
  { label: "Plain to -3.00 Add +1.25", value: "Plain to -3.00 Add +1.25" },
  { label: "Plain to -3.00 Add +1.00", value: "Plain to -3.00 Add +1.00" },

  // Cyl - Range -12.00 / -6
  { label: "-10.25 to -12.00 / -6", value: "-10.25 to -12.00 / -6" },
  { label: "-8.25 to -10.00 / -6", value: "-8.25 to -10.00 / -6" },
  { label: "-6.25 to -8.00 / -6", value: "-6.25 to -8.00 / -6" },
  { label: "-4.25 to -6.00 / -6", value: "-4.25 to -6.00 / -6" },
  { label: "-2.25 to -4.00 / -6", value: "-2.25 to -4.00 / -6" },
  { label: "Plain to -2.00 / -6", value: "Plain to -2.00 / -6" },
  { label: "-14.25 to -16.00 / -4", value: "-14.25 to -16.00 / -4" },
  { label: "-12.25 to -14.00 / -4", value: "-12.25 to -14.00 / -4" },
  { label: "-10.25 to -12.00 / -4", value: "-10.25 to -12.00 / -4" },
  { label: "-8.25 to -10.00 / -4", value: "-8.25 to -10.00 / -4" },
  { label: "-6.25 to -8.00 / -4", value: "-6.25 to -8.00 / -4" },
  { label: "-4.25 to -6.00 / -4", value: "-4.25 to -6.00 / -4" },
  { label: "-2.25 to -4.00 / -4", value: "-2.25 to -4.00 / -4" },
  { label: "Plain to -2.00 / -4", value: "Plain to -2.00 / -4" },
  { label: "-14.25 to -16.00 / -2", value: "-14.25 to -16.00 / -2" },
  { label: "-12.25 to -14.00 / -2", value: "-12.25 to -14.00 / -2" },
  { label: "-10.25 to -12.00 / -2", value: "-10.25 to -12.00 / -2" },
  { label: "-8.25 to -10.00 / -2", value: "-8.25 to -10.00 / -2" },
  { label: "-6.25 to -8.00 / -2", value: "-6.25 to -8.00 / -2" },
  { label: "-4.25 to -6.00 / -2", value: "-4.25 to -6.00 / -2" },
  { label: "-2.25 to -4.00 / -2", value: "-2.25 to -4.00 / -2" },
  { label: "Plain to -2.00 / -2", value: "Plain to -2.00 / -2" },

  //Sph - Range pln to -20.00
  { label: "-16.25 to -20.00", value: "-16.25 to -20.00" },
  { label: "-12.25 to -16.00", value: "-12.25 to -16.00" },
  { label: "-10.25 to -12.00", value: "-10.25 to -12.00" },
  { label: "-8.25 to -10.00", value: "-8.25 to -10.00" },
  { label: "-6.25 to -8.00", value: "-6.25 to -8.00" },
  { label: "-4.25 to -6.00", value: "-4.25 to -6.00" },
  { label: "-2.25 to -4.00", value: "-2.25 to -4.00" },
  { label: "Plain to -2.00", value: "Plain to -2.00" },
  
  { label: "All", value: "All" },
  { label: "Accessories", value: "Accessories" },

  //Sph + Range pln to +20.00
  { label: "Plain to +2.00", value: "0.00 to +2.00" },
  { label: "+2.25 to +4.00", value: "+2.25 to +4.00" },
  { label: "+4.25 to +6.00", value: "+4.25 to +6.00" },
  { label: "+6.25 to +8.00", value: "+6.25 to +8.00" },
  { label: "+8.25 to +10.00", value: "+8.25 to +10.00" },
  { label: "+10.25 to +12.00", value: "+10.25 to +12.00" },
  { label: "+12.25 to +16.00", value: "+12.25 to +16.00" },
  { label: "+16.25 to +20.00", value: "+16.25 to +20.00" },

// Cyl + Range +12.00 / +6
  { label: "Plain to +2.00 / +2", value: "Plain to +2.00 / +2" },
  { label: "+2.25 to +4.00 / +2", value: "+2.25 to +4.00 / +2" },
  { label: "+4.25 to +6.00 / +2", value: "+4.25 to +6.00 / +2" },
  { label: "+6.25 to +8.00 / +2", value: "+6.25 to +8.00 / +2" },
  { label: "+8.25 to +10.00 / +2", value: "+8.25 to +10.00 / +2" },
  { label: "+10.25 to +12.00 / +2", value: "+10.25 to +12.00 / +2" },
  { label: "+12.25 to +14.00 / +2", value: "+12.25 to +14.00 / +2" },
  { label: "+14.25 to +16.00 / +2", value: "+14.25 to +16.00 / +2" },
  { label: "Plain to +2.00 / +4", value: "Plain to +2.00 / +4" },
  { label: "+2.25 to +4.00 / +4", value: "+2.25 to +4.00 / +4" },
  { label: "+4.25 to +6.00 / +4", value: "+4.25 to +6.00 / +4" },
  { label: "+6.25 to +8.00 / +4", value: "+6.25 to +8.00 / +4" },
  { label: "+8.25 to +10.00 / +4", value: "+8.25 to +10.00 / +4" },
  { label: "+10.25 to +12.00 / +4", value: "+10.25 to +12.00 / +4" },
  { label: "+12.25 to +14.00 / +4", value: "+12.25 to +14.00 / +4" },
  { label: "+14.25 to +16.00 / +4", value: "+14.25 to +16.00 / +4" },
  { label: "Plain to +2.00 / +6", value: "Plain to +2.00 / +6" },
  { label: "+2.25 to +4.00 / +6", value: "+2.25 to +4.00 / +6" },
  { label: "+4.25 to +6.00 / +6", value: "+4.25 to +6.00 / +6" },
  { label: "+6.25 to +8.00 / +6", value: "+6.25 to +8.00 / +6" },
  { label: "+8.25 to +10.00 / +6", value: "+8.25 to +10.00 / +6" },
  { label: "+10.25 to +12.00 / +6", value: "+10.25 to +12.00 / +6" },

  //Cross Range +/-
  { label: "+0.25 to +1.00 `/` -0.50 to -2.00", value: "+0.25 to +1.00 `/` -0.50 to -2.00" },
  { label: "+1.25 to +2.00 `/` -2.25 to -4.00", value: "+1.25 to +2.00 `/` -2.25 to -4.00" },
  { label: "+2.25 to +4.00 `/` -4.25 to -6.00", value: "+2.25 to +4.00 `/` -4.25 to -6.00" },

  // Bifocals +
  { label: "Plain to +3.00 Add +1.00", value: "Plain to +3.00 Add +1.00" },
  { label: "Plain to +3.00 Add +1.25", value: "Plain to +3.00 Add +1.25" },
  { label: "Plain to +3.00 Add +1.50", value: "Plain to +3.00 Add +1.50" },
  { label: "Plain to +3.00 Add +1.75", value: "Plain to +3.00 Add +1.75" },
  { label: "Plain to +3.00 Add +2.00", value: "Plain to +3.00 Add +2.00" },
  { label: "Plain to +3.00 Add +2.25", value: "Plain to +3.00 Add +2.25" },
  { label: "Plain to +3.00 Add +2.50", value: "Plain to +3.00 Add +2.50" },
  { label: "Plain to +3.00 Add +2.75", value: "Plain to +3.00 Add +2.75" },
  { label: "Plain to +3.00 Add +3.00", value: "Plain to +3.00 Add +3.00" },
];
